import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Table from "../custom/tableWrapper/Table";
import { coulmnsType, DictionaryType, tableConfig } from "../../types";

import creataIcon from "../../assets/icons/CREATE.svg";

// import PricingSideBar from './PricingSideBar'
import SideBar from "../global/SideBar";
import { cn, formatDate } from "../../utils/utils";

import ClubsSidebar from "../clubs/clubsSidebar/ClubsSidebar";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";

import { useGetDictionary } from "../../hooks/useGetDictionary";
import WalletControll from "../clubs/WalletControll";
import WalletSidebar from "./WalletSidebar";
import WalletUserControll from "../clubs/WalletUserControll";
import { Tooltip } from "react-tooltip";
type Props = {
  data: any;
  columns: coulmnsType;
  page: "roles" | "users" | "players" | "memberships" | "packages" | "wallet";
};

function WalletUsersTable({ data, columns, page }: Props) {
  const clubId = useSelector((state: UserSliceType) => state.user.selectedClub);
  const lang = useSelector((state: any) => state?.user?.lang);
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [isModelTriggered, setIsModelTriggered] = useState(false);
  const [eventType, setEventType] = useState<"edit" | "view">("edit");
  const [row, setRow] = useState<any>({});
  const { options, inputs, shared }: DictionaryType = useGetDictionary();
  const navigate = useNavigate();

  const config: tableConfig = {
    status: {
      isCustomViewChildren: true,
      customViewChildren: (row, tag) => {
        return (
          <td className="flex-1 p-4  min-w-[150px] text-left">
            <Tooltip
              id="status"
              style={{
                backgroundColor: "lightgray",
                color: "#1e1850",
                top: "0px",
                zIndex: 1000,
                maxWidth: "300px",
                textWrap: "wrap",
              }}
            />
            <div
              data-tooltip-id="status"
              data-tooltip-content={row.reason}
              className={cn(
                "grid place-content-center px-4 py-2 rounded-3xl w-[100px] mx-auto ml-0",
                row[tag].toLowerCase() === "active"
                  ? "bg-[#34C759] text-primary dark:text-white"
                  : "text-[#F3F3F3] bg-[#EF4626]"
              )}
            >
              {row[tag].toLowerCase() === "active"
                ? inputs.active
                : inputs.inactive}
            </div>
          </td>
        );
      },
    },
    controll: {
      isCustomViewChildren: true,
      customViewChildren: (row, tag) => {
        return (
          <td
            onClick={(e) => {
              e.stopPropagation();
            }}
            className=" flex-1  relative  "
          >
            <div className="flex items-center justify-center">
              <WalletUserControll
                row={row}
                setEventType={setEventType}
                tag={tag}
                setRow={setRow}
                setSidebarOpen={setSidebarOpen}
                clubId={clubId}
                setIsModelTriggered={setIsModelTriggered}
              />
            </div>
          </td>
        );
      },
    },
  };

  return (
    <div className=" fixed-table customer-table printContainer">
      {sidebarOpen && (
        <SideBar
          setSidebarOpen={setSidebarOpen}
          sidebarOpen={sidebarOpen}
          headerImage={creataIcon}
          headerTitle={shared.create}
          sideBarMaxWidth={"max-w-[400px]"}
        >
          <WalletSidebar
            id={clubId}
            type={eventType}
            tableId={row.id}
            rowData={row}
            page={"userInfo"}
          />
        </SideBar>
      )}
      <Table
        tbodyClassName={cn(
          data?.length > 0 &&
            data?.length < 2 &&
            isModelTriggered &&
            "min-h-[400px] "
        )}
        columnsData={columns}
        rowData={data?.data}
        config={config}
        generalCellColumnClassName="  "
        generalCellRowClassName="  min-w-[150px] w- overflow-hidden text-left "
        generalRowClassName=" text-left relative hover:bg-gray-200 dark:hover:bg-primaryLight hover:cursor-pointer transition duration-300"
        generalColumnsClassName=" bg-[#F3F3F3] text-primary dark:text-white  static text-left "
        rowAction={(row: any) => {
          console.log(row);

          setSidebarOpen(true);
          if(!row?.id){
             setRow({...row,id:row?.relation_id});
          }else{
           setRow(row);
          }
          
         
        }}
      />
    </div>
  );
}

export default WalletUsersTable;
